
import { useState } from 'react';
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { User } from "@supabase/supabase-js";

export const useFavoriteToggle = (user: User | null, onFavoriteChange?: () => void) => {
  const [isTogglingFavorite, setIsTogglingFavorite] = useState(false);

  const handleFavoriteToggle = async (vacation: any, isFavorite: boolean) => {
    if (!user) {
      // For non-logged users, just show a message about temporary favorites
      toast.success(isFavorite ? "Verwijderd uit tijdelijke favorieten" : "Toegevoegd aan tijdelijke favorieten");
      onFavoriteChange?.();
      return;
    }

    setIsTogglingFavorite(true);
    try {
      if (isFavorite) {
        const { error } = await supabase
          .from('favorites')
          .delete()
          .eq('user_id', user.id)
          .eq('vacation_id', vacation['product ID']);
        
        if (error) throw error;
        toast.success("Verwijderd uit favorieten");
      } else {
        const { error } = await supabase
          .from('favorites')
          .insert({
            user_id: user.id,
            vacation_id: vacation['product ID'],
            vacation_data: vacation
          });
        
        if (error) throw error;
        toast.success("Toegevoegd aan favorieten");
      }
      
      onFavoriteChange?.();
    } catch (error: any) {
      toast.error("Er ging iets mis: " + error.message);
    } finally {
      setIsTogglingFavorite(false);
    }
  };

  return { handleFavoriteToggle, isTogglingFavorite };
};
